module.exports = __webpack_public_path__ + "heliasport.svg?7699c33110361056f9140b022d64fffb";